<div class="build-card">
  <h2>App Build</h2>

  <!-- Auto-Run Section -->
  <div class="auto-run-section">
    <h3>Automated Builds</h3>
    <p class="description">Automatically build all projects with incremented versions from app stores.</p>

    <div class="auto-run-controls">
      <!-- Platform Selection -->
      <div class="platform-select">
        <label>Platforms:</label>
        <div class="platform-checkboxes">
          <label>
            <input type="checkbox" [(ngModel)]="buildAndroid" [disabled]="autoRunning">
            Android (Google Play)
          </label>
          <label>
            <input type="checkbox" [(ngModel)]="buildIos" [disabled]="autoRunning">
            iOS (App Store)
          </label>
        </div>
      </div>

      <div class="build-type-select" *ngIf="buildAndroid">
        <label>Android Build Type:</label>
        <select [(ngModel)]="autoRunBuildType" [disabled]="autoRunning">
          <option value="aab">AAB (App Bundle)</option>
          <option value="">APK</option>
        </select>
      </div>

      <div class="auto-upload-toggle" *ngIf="buildAndroid">
        <label>
          <input type="checkbox" [(ngModel)]="autoRunAutoUpload" [disabled]="autoRunning">
          Auto-upload to Google Play and submit for review
        </label>
      </div>

      <div class="auto-run-buttons">
        <button
          type="button"
          class="btn-auto-run"
          (click)="startAutoRun()"
          [disabled]="autoRunning || (!buildAndroid && !buildIos)">
          Start Auto Build All
        </button>
        <button
          type="button"
          class="btn-cancel"
          (click)="cancelAutoRun()"
          [disabled]="!autoRunning">
          Cancel
        </button>
      </div>
    </div>

    <!-- What's New Section -->
    <div class="whats-new-section" *ngIf="autoRunAutoUpload || buildIos">
      <label>What's New (Release Notes)</label>
      <textarea
        [(ngModel)]="autoRunWhatsNew"
        [disabled]="autoRunning"
        placeholder="Bug fixes and performance improvements"
        rows="3"
        class="whats-new-textarea">
      </textarea>
      <small>This text will be used as release notes for all apps built in this run</small>
    </div>

    <!-- Progress Display -->
    <div class="auto-run-progress" *ngIf="autoRunning && currentProgress">
      <div class="current-platform-badge">
        <span class="platform-badge" [class.android]="currentPlatform === 'android'" [class.ios]="currentPlatform === 'ios'">
          {{ currentPlatform === 'android' ? 'Android' : 'iOS' }}
        </span>
      </div>
      <div class="progress-info">
        <span>Processing project {{ currentProgress.currentIndex }} of {{ currentProgress.totalProjects }}</span>
        <span *ngIf="currentPlatform === 'android' && androidProgress.currentPackageName">
          Current: {{ androidProgress.currentPackageName }} (ID: {{ androidProgress.currentProject }})
        </span>
        <span *ngIf="currentPlatform === 'ios' && iosProgress.currentBundleId">
          Current: {{ iosProgress.currentBundleId }} (ID: {{ iosProgress.currentProject }})
        </span>
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar" [style.width.%]="(currentProgress.currentIndex / currentProgress.totalProjects) * 100"></div>
      </div>
      <!-- Build Progress for current project -->
      <div class="build-progress-info" *ngIf="currentProgress.currentBuildStatus">
        <span class="build-status">Build Status: {{ currentProgress.currentBuildStatus }}</span>
        <span class="build-percent">{{ currentProgress.currentBuildProgress }}%</span>
      </div>
      <div class="progress-bar-container build-bar" *ngIf="currentProgress.currentBuildProgress > 0">
        <div class="progress-bar build" [style.width.%]="currentProgress.currentBuildProgress"></div>
      </div>
    </div>

    <!-- Combined Summary Display -->
    <div class="auto-run-summary" *ngIf="autoRunSummary.android || autoRunSummary.ios">
      <h4>Build Summary</h4>
      <div class="summary-stats">
        <span class="stat completed">Completed: {{ totalCompleted }}</span>
        <span class="stat failed">Failed: {{ totalFailed }}</span>
        <span class="stat skipped">Skipped: {{ totalSkipped }}</span>
      </div>

      <!-- Android Summary -->
      <div class="platform-summary" *ngIf="autoRunSummary.android">
        <h4 class="platform-header android">Android Results</h4>

        <!-- Android Completed Builds Table -->
        <div class="summary-table" *ngIf="autoRunSummary.android.completed.length > 0">
          <h5>Completed Builds</h5>
          <table>
            <thead>
              <tr>
                <th>Package Name</th>
                <th>Project ID</th>
                <th>Old Version</th>
                <th>New Version</th>
                <th>Download</th>
                <th>Upload</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.android.completed">
                <td>{{ build.packageName }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.oldVersion }} ({{ build.oldVersionCode }})</td>
                <td>{{ build.newVersion }} ({{ build.newVersionCode }})</td>
                <td>
                  <a *ngIf="build.aabUrl" [href]="build.aabUrl" target="_blank" rel="noopener" class="download-link">AAB</a>
                  <a *ngIf="build.apkUrl" [href]="build.apkUrl" target="_blank" rel="noopener" class="download-link">APK</a>
                  <span *ngIf="!build.aabUrl && !build.apkUrl">-</span>
                </td>
                <td>
                  <span *ngIf="build.uploadStatus === 'success'" class="upload-badge success">Uploaded</span>
                  <span *ngIf="build.uploadStatus === 'failed'" class="upload-badge failed" [title]="build.uploadError">Failed</span>
                  <span *ngIf="build.uploadStatus === 'skipped'" class="upload-badge skipped">Skipped</span>
                  <span *ngIf="!build.uploadStatus">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Android Failed Builds Table -->
        <div class="summary-table" *ngIf="autoRunSummary.android.failed.length > 0">
          <h5>Failed Builds</h5>
          <table>
            <thead>
              <tr>
                <th>Package Name</th>
                <th>Project ID</th>
                <th>Version</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.android.failed">
                <td>{{ build.packageName }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.newVersion }} ({{ build.newVersionCode }})</td>
                <td class="error-cell">{{ build.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Android Skipped Projects Table -->
        <div class="summary-table" *ngIf="autoRunSummary.android.skipped.length > 0">
          <h5>Skipped Projects</h5>
          <table>
            <thead>
              <tr>
                <th>Package Name</th>
                <th>Project ID</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.android.skipped">
                <td>{{ build.packageName }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- iOS Summary -->
      <div class="platform-summary" *ngIf="autoRunSummary.ios">
        <h4 class="platform-header ios">iOS Results</h4>

        <!-- iOS Completed Builds Table -->
        <div class="summary-table" *ngIf="autoRunSummary.ios.completed.length > 0">
          <h5>Completed Builds</h5>
          <table>
            <thead>
              <tr>
                <th>Bundle ID</th>
                <th>Project ID</th>
                <th>Old Version</th>
                <th>New Version</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.ios.completed">
                <td>{{ build.bundleId }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.oldVersion }}</td>
                <td>{{ build.newVersion }}</td>
                <td>
                  <a *ngIf="build.ipaUrl" [href]="build.ipaUrl" target="_blank" rel="noopener" class="download-link">IPA</a>
                  <span *ngIf="!build.ipaUrl">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- iOS Failed Builds Table -->
        <div class="summary-table" *ngIf="autoRunSummary.ios.failed.length > 0">
          <h5>Failed Builds</h5>
          <table>
            <thead>
              <tr>
                <th>Bundle ID</th>
                <th>Project ID</th>
                <th>Version</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.ios.failed">
                <td>{{ build.bundleId }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.newVersion }}</td>
                <td class="error-cell">{{ build.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- iOS Skipped Projects Table -->
        <div class="summary-table" *ngIf="autoRunSummary.ios.skipped.length > 0">
          <h5>Skipped Projects</h5>
          <table>
            <thead>
              <tr>
                <th>Bundle ID</th>
                <th>Project ID</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let build of autoRunSummary.ios.skipped">
                <td>{{ build.bundleId }}</td>
                <td>{{ build.projectId }}</td>
                <td>{{ build.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <p *ngIf="statusMsg" class="status-msg">{{ statusMsg }}</p>
  <p *ngIf="errorMsg" class="error-msg">{{ errorMsg }}</p>
</div>
